<div class="container-app">
  <div class="summary" style="background: var(--Contrast-h1, #3a3c5d)">
    <div class="detail">
      <div class="button" style="display: flex; justify-content: space-between">
        <a class="btn-return" role="button" (click)="goBack()"
          ><i class="pi pi-arrow-left" style="font-size: 14px"></i>Volver</a
        >
        <svg
          class="globot"
          xmlns="http://www.w3.org/2000/svg"
          width="42"
          height="40"
          viewBox="0 0 42 40"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.758789 18.7107C0.758789 8.48647 10.2723 0.668915 21.3795 0.668915C32.4866 0.668915 42.0001 8.48647 42.0001 18.7107C42.0001 28.9349 32.4866 36.7524 21.3795 36.7524C20.0819 36.7524 18.7844 36.6501 17.503 36.4348C14.5633 38.5507 10.9722 39.5575 7.35955 39.2883C7.02574 39.2668 6.7081 39.1537 6.42813 38.9706C6.14816 38.7876 5.92741 38.5345 5.77666 38.2384C5.6259 37.9423 5.55054 37.6139 5.56669 37.2801C5.58284 36.9463 5.67975 36.6232 5.85204 36.3432C6.69733 34.9811 7.16035 33.4197 7.19804 31.8153C3.27849 28.5688 0.758789 23.9278 0.758789 18.7107Z"
            fill="white"
          />
          <path
            d="M21.3794 30.8678C29.7052 30.8678 36.4545 25.6419 36.4545 19.1954C36.4545 12.7488 29.7052 7.52286 21.3794 7.52286C13.0536 7.52286 6.3042 12.7488 6.3042 19.1954C6.3042 25.6419 13.0536 30.8678 21.3794 30.8678Z"
            fill="#27283B"
          />
          <path
            d="M16.523 15.599C17.7667 15.599 18.7735 16.6058 18.7735 17.8495V20.8322C18.7735 22.0759 17.7667 23.0827 16.523 23.0827C15.2793 23.0827 14.2725 22.0759 14.2725 20.8322V17.8495C14.2725 16.6058 15.2793 15.599 16.523 15.599Z"
            fill="#DA94FB"
          />
          <path
            d="M26.6558 15.599C27.8995 15.599 28.9063 16.6058 28.9063 17.8495V20.8322C28.9063 22.0759 27.8995 23.0827 26.6558 23.0827C25.4121 23.0827 24.4053 22.0759 24.4053 20.8322V17.8495C24.4053 16.6058 25.4121 15.599 26.6558 15.599Z"
            fill="#DA94FB"
          />
        </svg>
      </div>
      <div class="plan">
        <span style="font-size: 19px; font-weight: 600">Plan {{ planType }}</span>
        <div class="price" style="font-size: 24px; font-weight: 700">
          <span class="numerator">${{ planPrice }}</span>
          <span class="denominator" style="color: #8f8f97">/Mes</span>
        </div>
        <div class="iva" style="font-size: 16px; color: #f8fafc; font-weight: 400">
          IVA incluido
        </div>
      </div>
      <div class="total" style="color: var(--color-primary-light)">
        <div class="total-detail">
          <span style="min-width: 210px">Plan {{ planType }} (IVA incluido)</span>
          <span style="font-weight: 700; font-size: 16px">${{ planPrice }}</span>
        </div>
        <div style="width: 100%; height: 1px; border-top: 1px solid #8f8f97"></div>
        <div class="total-payment">
          <span>Total</span>
          <span style="font-weight: 700; font-size: 16px">${{ planPrice }}</span>
        </div>
      </div>
    </div>
    <div class="footer">
      <span>Medio de pago</span>
      <span>
        <img src="assets/img/webpay.svg" alt="Webpay" height="39" />
      </span>
    </div>
  </div>
  <div class="form">
    <div class="logo">
      <img src="assets/icons/globot.svg" alt="globot" height="33" />
    </div>
    <div class="subscriptionForm">
      <h1>Ingresa tus datos de suscripción</h1>
      <form class="bodyForm" [formGroup]="subscriptionForm">
        <div class="flex-auto">
          <label for="email"> Email </label>
          <input
            pInputText
            type="text"
            formControlName="email"
            id="email"
            [readonly]="true"
            style="background: #e5e9ee; color: var(--color-text)"
          />
        </div>
        <div class="flex-auto">
          <label for="name_on_invoice"> Nombre y Apellido </label>
          <input
            pInputText
            formControlName="name_on_invoice"
            id="name_on_invoice"
            formControlName="name_on_invoice"
            placeholder="Tu nombre completo"
            [ngClass]="getInputClass('name_on_invoice')"
          />
          <div
            *ngIf="
              subscriptionForm.controls['name_on_invoice'].invalid &&
              subscriptionForm.controls['name_on_invoice'].touched
            "
            class="error-message"
          >
            {{ getErrorMessage('name_on_invoice') }}
          </div>
        </div>
        <div class="flex-auto">
          <label for="document_value"> RUT </label>
          <input
            pInputText
            formControlName="document_value"
            id="document_value"
            formControlName="document_value"
            placeholder="Ej: 1234456789"
            (blur)="onblur()"
            [ngClass]="getInputClass('document_value')"
            [readonly]="noRut"
            [ngStyle]="noRut ? { 'background-color': '#E5E9EE', color: 'var(--color-text)' } : {}"
          />
          <p-checkbox
            class="mt-3"
            name="noRut"
            (onChange)="checkboxRut($event)"
            [binary]="true"
            [ngModel]="noRut"
            [ngModelOptions]="{ standalone: true }"
            label="No tengo RUT"
          >
          </p-checkbox>
          <div
            *ngIf="
              subscriptionForm.controls['document_value'].invalid &&
              subscriptionForm.controls['document_value'].touched
            "
            class="error-message"
          >
            {{ getErrorMessage('document_value') }}
          </div>
        </div>
        <div class="flex-auto phone-input-container">
          <label for="phone">Teléfono</label>
          <div class="phone-input">
            <select
              formControlName="country"
              (change)="onCountryChange($event)"
              class="country-selector"
              style="height: 40px; border: 1px solid var(--color-border-light); font-size: 25px"
            >
              <option *ngFor="let country of countries" [value]="country.dial_code">
                {{ country.flag }}
              </option>
            </select>
            <span>{{ getCodeNumber() }}</span>
            <input
              type="tel"
              formControlName="phone"
              pKeyFilter="int"
              id="phone"
              placeholder="Ej: 9 1234 5678"
              class="phone-input-field"
              style="height: 40px; border-radius: 6px"
              [ngClass]="getInputClass('phone')"
            />
          </div>
          <div
            *ngIf="
              subscriptionForm.controls['phone'].invalid &&
              subscriptionForm.controls['phone'].touched
            "
            class="error-message"
          >
            {{ getErrorMessage('phone') }}
          </div>
        </div>

        <button (click)="onSubmit()" class="btn-subscribe" [disabled]="!isFormValid() || loading" aria-label="Pagar con Webpay">
          <img *ngIf="!loading" src="assets/img/webpay.svg" alt="Webpay" class="btn-webpay-img" />
          <p-progressSpinner
            *ngIf="loading"
            [style]="{ width: '18px', height: '18px' }"
            ariaLabel="loading"
            animationDuration=".5s"
          ></p-progressSpinner>
        </button>

        <div class="flex-auto accept-terms-block mt-3">
          <div class="accept-terms-row">
            <p-checkbox
              formControlName="acceptTerms"
              [binary]="true"
              inputId="acceptTerms"
            ></p-checkbox>
            <label for="acceptTerms" class="checkbox-label">
              Acepto que Globot cobrará en mi tarjeta el importe indicado arriba ahora y de forma
              recurrente cada mes hasta que cancele, de acuerdo con nuestros
              <a [href]="termsUrl" target="_blank" rel="noopener noreferrer">términos y condiciones</a>.
              Puedo cancelar en cualquier momento.
            </label>
          </div>
          <div
            *ngIf="
              subscriptionForm.controls['acceptTerms'].invalid &&
              subscriptionForm.controls['acceptTerms'].touched
            "
            class="error-message"
          >
            Debes aceptar los términos y condiciones
          </div>
        </div>
      </form>
      <div class="footer-2">
        <div class="pay">
          <span style="font-size: 14px">Medio de pago</span>
          <div class="medios">
            <img src="assets/img/webpayColor.svg" alt="Webpay" height="38.6" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
